import { Button, Card, CardContent, CardHeader, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import MaterialTable from 'src/components/SelectMaterial/materialControl';
import { saveUrunControlDetail, loadUrunControlDetail } from 'src/utils/storage/StartWorkOrder';
import { checkHizmet } from 'src/utils/storage/Defect';
import { checkIscilik } from 'src/utils/storage/Labour';
import { checkMalzeme } from 'src/utils/storage/Material';
import { getDefectRequest, getLabourRequest, getMaterialRequest } from '../../store/actions';
import { addDefects, resetDefects } from '../../store/actions/defectActions';
import { addLabours, resetLabours } from '../../store/actions/labourActions';
import { addMaterials, resetMaterials } from '../../store/actions/materialActions';
import Alert from '@material-ui/lab/Alert';
import { safeParseInt } from 'src/utils/Common';

const useStyles = makeStyles(() => ({
  root: {},
}));

function Hizmet({ 
  defectReducer, 
  materialReducer, 
  labourReducer,
  getDefectRequest,
  getLabourRequest,
  getMaterialRequest,
  resetDefects,
  resetLabours,
  resetMaterials,
  addDefects,
  addLabours,
  addMaterials
}) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [Uyari, setUyari] = React.useState("");
  const HizmetData = loadUrunControlDetail();

  // DÜZELTME: loading tanımını en yukarıya, useEffect'lerden öncesine alıyoruz
  const loading = defectReducer?.loading || materialReducer?.loading || labourReducer?.loading;

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {

    if (loadUrunControlDetail().length === 0) {
      return;
    }



    let kulmodelkodu = loadUrunControlDetail()[0]?.KUL_MODEL_KODU;
    let uyil = loadUrunControlDetail()[0]?.UYIL || 0;
    let udonem = loadUrunControlDetail()[0]?.UDONEM || 0;
    let SerialNr = loadUrunControlDetail()[0]?.SERINO || '0';

    if (!kulmodelkodu) {
      return;
    }

    if (defectReducer.Data.length === 0) {
      resetDefects();
      getDefectRequest(kulmodelkodu, 1);
    }
    if (materialReducer.Data.length === 0) {
      resetMaterials();
      getMaterialRequest(kulmodelkodu, 1, 1, uyil, udonem, SerialNr);
    }
    if (labourReducer.Data.length === 0) {
      resetLabours();
      getLabourRequest(kulmodelkodu, 1, 1);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (loadUrunControlDetail().length === 0) {
      return;
    }
    let kulmodelkodu = loadUrunControlDetail()[0]?.KUL_MODEL_KODU;
    let uyil = loadUrunControlDetail()[0]?.UYIL;
    let udonem = loadUrunControlDetail()[0]?.UDONEM;
    let SerialNr = loadUrunControlDetail()[0]?.SERINO || '0';

    if (!kulmodelkodu) {
      return;
    }

    if (!checkHizmet(kulmodelkodu)) {
      resetDefects();
      getDefectRequest(kulmodelkodu, 1);
    }
    if (!checkMalzeme(kulmodelkodu)) {
      resetMaterials();
      getMaterialRequest(kulmodelkodu, 1, 1, uyil, udonem, SerialNr);
    }
    if (!checkIscilik(kulmodelkodu)) {
      resetLabours();
      getLabourRequest(kulmodelkodu, 1, 1);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (loadUrunControlDetail().length === 0) {
      return;
    }
    const merkez = loadUrunControlDetail();

    setUyari("Fişe verilmiş hizmetler merkezden tekrardan alınıyor!..");
    setOpen(true);
    resetDefects();
    resetMaterials();
    resetLabours();
    getDefectRequest(merkez[0]?.KUL_MODEL_KODU, 1);
    getMaterialRequest(merkez[0]?.KUL_MODEL_KODU, 1, 1, merkez[0]?.UYIL || 0, merkez[0]?.UDONEM || 0, merkez[0]?.SERINO || 0);
    getLabourRequest(merkez[0]?.KUL_MODEL_KODU, 1, 1);
    let curr = merkez[0];
    if (curr.HIZMETLER) {
      const selectedDefects = [];
      let laboursHizmet = {};
      let materialsHizmet = {};
      curr.HIZMETLER.forEach(function (h) {
        selectedDefects.push(h.HIZMET_KODU);
        laboursHizmet = { ...laboursHizmet, [h.HIZMET_KODU]: [] };
        materialsHizmet = { ...materialsHizmet, [h.HIZMET_KODU]: [] };
      });
      addDefects(selectedDefects);
      if (curr.ISCILIKLER) {
        curr.ISCILIKLER.forEach(function (i) {
          laboursHizmet[i.HIZMET_KODU].push(i.KUL_ISCILIK_KODU.toString());
        });
        addLabours(laboursHizmet);
      }
      if (curr.MALZEMELER) {
        curr.MALZEMELER.forEach(function (i) {
          materialsHizmet[i.HIZMET_KODU].push(i.MALZEME_STOK_NO.toString());
          materialsHizmet = { ...materialsHizmet, [i.MALZEME_STOK_NO]: i.ADET }
        });
        addMaterials(materialsHizmet);
      }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {

    if (!loading) {
      localStorageKaydet();
    }
    // eslint-disable-next-line
  }, [defectReducer, materialReducer, labourReducer]);

  const localStorageKaydet = () => {
    if (defectReducer.Data.length === 0) {
      return;
    }
    let job = loadUrunControlDetail()[0];
    let hizmetlerH = [];
    let isciliklerH = [];
    let malzemelerH = [];
    let iscilik_toplam = 0;
    let malzeme_toplam = 0;
    for (let h = 0; h < defectReducer.selected.length; h++) {
      const hizmet = defectReducer.selected[h];
      const hizmetRedux = defectReducer.defectsTable[hizmet];
      hizmetlerH.push({
        HIZMET_KODU: hizmet,
        KUL_HIZMET_KODU: hizmetRedux?.UserCode,
        ACIKLAMA: hizmetRedux?.DefectDesc,
        TIP: hizmetRedux?.DefectType,
        TIP_KODU: hizmetRedux?.DefectTypeCode,
      });
      const labourArray = labourReducer[hizmet];
      if (labourArray && labourArray.length > 0) {
        for (let i = 0; i < labourArray.length; i++) {
          const iscilik = labourReducer.Data.filter(d => d.LabourCode === labourArray[i])[0];
          if (iscilik) {
            isciliklerH.push({
              ISCILIK_KODU: iscilik?.LabourId,
              HIZMET_KODU: hizmet,
              KUL_ISCILIK_KODU: iscilik?.LabourCode,
              ACIKLAMA: iscilik?.LabourDesc,
              FIYAT: safeParseInt(job?.GARANTI_TIPI) === 1 ? (iscilik?.PriceWithoutWarranty || 0) : (iscilik?.Price || 0),
              FIYAT_LISTESI_ID: parseInt(job?.GARANTI_TIPI) === 1 ? iscilik?.PriceListIdWithoutWarranty : iscilik?.PriceListId,
              FIYAT_KODU: safeParseInt(iscilik?.PriceId)
            });
            iscilik_toplam += safeParseInt(job?.GARANTI_TIPI) === 1 ? (iscilik?.PriceWithoutWarranty || 0) : (iscilik?.Price || 0);
          }
        }
      }
      const materialArray = materialReducer[hizmet];
      if (materialArray && materialArray.length > 0) {
        for (let m = 0; m < materialArray.length; m++) {
          const malzeme = materialReducer.Data.filter(d => d.MaterialCode === materialArray[m])[0];
          if (malzeme) {
            malzemelerH.push({
              MALZEME_KODU: malzeme.MaterialId,
              HIZMET_KODU: hizmet,
              MALZEME_STOK_NO: malzeme.MaterialCode,
              ADET: materialReducer[malzeme.MaterialCode],
              ACIKLAMA: malzeme?.MaterialDesc,
              FIYAT: malzeme?.PriceWithWat,
              FIYAT_LISTESI_ID: malzeme.PriceListId,
              FIYAT_KODU: safeParseInt(malzeme.PriceId)
            })
            malzeme_toplam += materialReducer[malzeme.MaterialCode] * malzeme?.PriceWithWat;
          }
        }
      }
    }
    job = {
      ...job,
      HIZMETLER: hizmetlerH,
      ISCILIKLER: isciliklerH,
      MALZEMELER: malzemelerH,
      ISCILIK_TOPLAM: iscilik_toplam,
      MALZEME_TOPLAM: malzeme_toplam,
    }
    saveUrunControlDetail(job);
  }

  if (HizmetData === undefined || HizmetData === '' || HizmetData === null || HizmetData.length === 0) {
    return <Card>
      <CardHeader title="Ürün Kontrolü" />
      <Divider />
      <CardContent>
        <Alert severity="info">Ürün seçimi yapılmadığı için malzemeler listelenemiyor!... Lütfen önce ürün seçimi yapınız!...</Alert>
      </CardContent>
    </Card>;
  }

  if (HizmetData[0]?.KUL_MODEL_KODU === undefined || HizmetData[0]?.KUL_MODEL_KODU === '' || HizmetData[0]?.KUL_MODEL_KODU === null) {
    return <Card>
      <CardHeader title="Ürün Kontrolü" />
      <Divider />
      <CardContent>
        <Alert severity="info">Ürün seçimi yapılmadığı için malzemeler listelenemiyor!... Lütfen önce ürün seçimi yapınız!...</Alert>
      </CardContent>
    </Card>;
  }





  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">{"Bilgilendirme"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
      {defectReducer.error.length > 0 && <Typography>Hizmet Hata: {defectReducer.error}</Typography>}
      {labourReducer.error.length > 0 && <Typography>İşçilik Hata: {labourReducer.error}</Typography>}
      {materialReducer.error.length > 0 && <Typography>Hizmet Hata: {materialReducer.error}</Typography>}
      {
        (loading || defectReducer.Data.length === 0 || materialReducer.Data.length === 0 || labourReducer.Data.length === 0) ?
          (defectReducer.Data.length === 0 && !window.navigator.onLine ? (
            <Card>
              <CardHeader title="Offline Data Kontrolü" />
              <Divider />
              <CardContent className={classes.contentH}>
                <Alert severity="info">Offline Olduğunuz sırada merkezden datalar alınamadığı için sayfa görüntülenemiyor. Online olduktan sonra tekrar deneyiniz.</Alert>
              </CardContent>
            </Card>
          ) : (
            <CircularProgress
              status={'loading'}
              style={{ marginLeft: '50%' }}
            />
          ))
          :
          <MaterialTable defect={0} GosterimAdet={30} />
      }
    </div>
  );
}

Hizmet.propTypes = {
  className: PropTypes.string,
};


export default connect(
  state => ({
    tasks: state.tasks1,
    defectReducer: state.defectReducer,
    labourReducer: state.labourReducer,
    materialReducer: state.materialReducer,
    resetDefects: state.resetDefects,
    resetLabours: state.resetLabours,
    resetMaterials: state.resetMaterials,
  }), {
  resetDefects, resetLabours, resetMaterials, getDefectRequest, getLabourRequest, getMaterialRequest, addDefects, addLabours, addMaterials
}
)(Hizmet);
